import { createFileRoute } from '@tanstack/react-router'
import { EditGroupDialogPending } from '@/routes/_app/-components/shared/dialog-pending'
import { useModalSlot } from '@/components/custom/modal-slot'
import EditGroupDialog from '@/routes/_app/-dialogs/edit-group'

export const Route = createFileRoute('/@modal/groups/$groupId/edit')({
  staticData: { slotScope: '/_app/orgs' },
  pendingComponent: EditGroupDialogPending,
  component: EditGroupSlot,
})

function EditGroupSlot() {
  const { params, ...slot } = useModalSlot(Route)
  return <EditGroupDialog groupId={params.groupId} {...slot} />
}
